import { useState } from 'react'
import MusicianImage from './MusicianImage/musicianImage'
import MusicianSkills from './MusicianSkills/musicianSkills'
import { Edit, Done } from '@mui/icons-material'
import MusicianLocation from './MusicianLocation/musicianLocation'
import MusicianSocialLinks from './MusicianSocialLinks/musicianSocialLinks'
import MusicianName from './MusicianName/musicianName'
import MusicianContactForm from './MusicianContactForm/musicianContactForm'
import MusicianAbout from './MusicianAbout/musicianAbout'
import MusicianGenres from './MusicianGenres/musicianGenres'
import MusicianPortfolio from './MusicianPortfolio/musicianPortfolio'
import { useAuth0 } from '@auth0/auth0-react'
import { useAtom } from 'jotai'
import { useLocation, useParams } from 'react-router-dom'
import React from 'react'
import userClient from '../../Api/Lirari/Clients/userClient'
import { unauthenticatedUserAtom } from '../../State/Musician/unauthenticatedUserAtom'
import { myUserAtom } from '../../State/Musician/myUserAtom'
import ShareButton from './ShareButton/shareButton'

const MusicianPage = () => {
  const { isAuthenticated, isLoading } = useAuth0()
  const [editMode, setEditMode] = useState(false)
  const [, setUnauthenticatedUser] = useAtom(unauthenticatedUserAtom)
  const [myUser] = useAtom(myUserAtom)

  const location = useLocation()
  const { uid: userId } = useParams()

  React.useEffect(() => {
    ;(async () => {
      if (userId) {
        const lirariUser = await userClient.getUserById(userId)
        setUnauthenticatedUser({
          id: lirariUser.id,
          auth0Id: lirariUser.auth0Id,
          firstName: lirariUser.firstName,
          lastName: lirariUser.lastName,
          email: lirariUser.email,
          about: lirariUser.about,
          locationFormattedString: lirariUser.locationFormattedString,
          socialLinks: {
            youtube: lirariUser.youTubeUrl,
            spotify: lirariUser.spotifyUrl,
            soundCloud: lirariUser.soundCloudUrl,
          },
          userSkills: lirariUser.userSkills ?? [],
          userGenres: lirariUser.userGenres ?? [],
          userOfferings: lirariUser.userOfferings ?? [],
          profileImageUrl:
            lirariUser.profileImageUrl ||
            'https://storage.googleapis.com/demo-profile/images/the-musician-unblurred.png',
          portfolioLinks: lirariUser.portfolioLinks ?? [],
          profileAudioUrl:
            lirariUser.profileAudioUrl || 'https://storage.googleapis.com/demo-profile/audio/Wartime%204.3.m4a',
        })
      }
    })()
  }, [userId, setUnauthenticatedUser])

  return isLoading ? (
    <div>Loading ...</div>
  ) : (
    (isAuthenticated || location.pathname == '/example-profile' || userId) && (
      <div className="lg:h-full">
        <div className={`flex flex-col relative bg-[#242424] h-full lg:hidden`}>
          {userId && myUser.id == userId ? (
            <button
              className="z-[99] flex absolute items-center justify-center top-2.5 right-2.5 rounded-full bg-[#8830C7] hover:bg-[#8830C7]/90 size-14 cursor-pointer [&>svg]:size-7"
              onClick={() => setEditMode(!editMode)}
            >
              {editMode ? <Done className="text-black" /> : <Edit className="text-black" />}
            </button>
          ) : null}

          <div className="flex flex-col pt-[8vh] z-10">
            <MusicianImage editMode={editMode} />
            <MusicianSkills editMode={editMode} />
            <MusicianName editMode={editMode} />
            <MusicianLocation editMode={editMode} />
            <div className="pt-[2vh] flex flex-row justify-center">
              <ShareButton editMode={editMode} />
              <MusicianContactForm editMode={editMode} />
              <MusicianSocialLinks editMode={editMode} />
            </div>
            <div className="flex flex-row justify-center pt-[4vh] px-[2vw]">
              <MusicianAbout editMode={editMode} />
            </div>
            <div className="flex flex-row justify-center pt-[4vh] px-[2vw]">
              <MusicianGenres editMode={editMode} />
            </div>
            <div className="flex flex-row justify-center pt-[4vh] px-[2vw]">
              <MusicianPortfolio editMode={editMode} />
            </div>
          </div>
        </div>
        {/* Desktop below mobile above */}
        <div
          className={`relative hidden lg:flex lg:flex-col relative bg-no-repeat h-full min-w-[1180px] min-h-[820px] bg-[#242424]`}
        >
          {userId && myUser.id == userId ? (
            <button
              className="z-20 flex absolute items-center justify-center top-2.5 right-2.5 rounded-full bg-white hover:bg-[#cdcdcd]/90 size-14 cursor-pointer [&>svg]:text-black [&>svg]:size-7"
              onClick={() => setEditMode(!editMode)}
            >
              {editMode ? <Done /> : <Edit />}
            </button>
          ) : null}

          <div className="px-20 h-full z-10">
            <div className="flex flex-row">
              <div className="w-1/4 flex flex-col justify-end">
                <MusicianName editMode={editMode} />
              </div>
              <div className="w-1/2">
                <MusicianImage editMode={editMode} />
              </div>
              <div className="w-1/4" />
            </div>
            <div className="flex flex-row">
              <div className="w-1/4">
                <MusicianLocation editMode={editMode} />
              </div>
              <div className="w-1/2">
                <MusicianSkills editMode={editMode} />
              </div>
              <div className="w-1/4 relative">
                <ShareButton editMode={editMode} />
                <MusicianContactForm editMode={editMode} />
                <MusicianSocialLinks editMode={editMode} />
              </div>
            </div>
          </div>
          <div className="px-20 pt-14 h-full z-10">
            <div className="flex flex-row h-full">
              <div className="w-1/4 flex flex-row h-full">
                <MusicianGenres editMode={editMode} />
              </div>
              <div className="w-1/2 flex flex-row justify-center h-full">
                <MusicianAbout editMode={editMode} />
              </div>
              <div className="w-1/4 flex flex-row h-full">
                <MusicianPortfolio editMode={editMode} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default MusicianPage
